import {
    Component,
    Input,
    HostBinding
} from '@angular/core';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { map, filter } from 'rxjs/operators';

@Component({
    selector: 'app-decoration-description',
    templateUrl: './decoration-description.component.pug',
    styleUrls: ['./decoration-description.component.less']
})
export class DecorationDescriptionComponent {
    _decoration: any;
    _decorationSbj: BehaviorSubject<any> = new BehaviorSubject({});
    decoration$: Observable<any> = this._decorationSbj.asObservable();

    @Input() set decoration(decoration) {
        this._decoration = decoration;
        this._decorationSbj.next(decoration);
    }
    get decoration() {
        return this._decoration;
    }

    _themesSbj: BehaviorSubject<any[]> = new BehaviorSubject([]);
    themes$: Observable<any[]> = this._themesSbj.asObservable();
    @Input() set themes(themes) {
        this._themesSbj.next(themes || []);
    }

    theme$ = combineLatest(this.decoration$, this.themes$)
        .pipe(map(([{ theme }, themes]) => themes.find(({ _id }) => theme === _id) || {}));

    description$ = this.decoration$
        .pipe(filter((decoration) => decoration))
        .pipe(map(({ groupDescription }) => groupDescription || ''));

    @Input() showContent: boolean = false;

    @HostBinding('class') get _class() {
        return `--rarity-${ this.decoration.rarity }`;
    }

    constructor(
    ) {
    }
}
